import React from 'react';
import './FrontPage.css';
import videoBg from '../assets/background-video.mp4';
import { getTenantConfig } from '../tenantConfig';

const FrontPage = ({ onLoginClick }) => {
  const tenant = getTenantConfig();
  const showVideo = tenant.isDefaultTenant;

  return (
    <div
      className={`front-page-container ${showVideo ? 'front-page--video' : 'front-page--branded'}`}
    >
      {showVideo ? (
        <video className="background-video" autoPlay loop muted playsInline>
          <source src={videoBg} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      ) : (
        <div className="front-page-branded-bg" aria-hidden="true" />
      )}

      <div className={`overlay ${showVideo ? '' : 'overlay--branded'}`.trim()}>
        {!showVideo && (
          <div className="front-page-brand">
            <h1 className="front-page-brand__name">{tenant.displayName}</h1>
            <p className="front-page-brand__tagline">Welcome — sign in to continue</p>
          </div>
        )}

        <div className="header">
          <button type="button" className="admin-login" onClick={onLoginClick}>
            Admin Login
          </button>
        </div>

        {showVideo && <div className="content" />}
      </div>
    </div>
  );
};

export default FrontPage;
